import { render } from "./RegionDashboardsAdditionFilterBlock.vue?vue&type=template&id=0e0bd85c&scoped=true&ts=true"
import script from "./RegionDashboardsAdditionFilterBlock.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsAdditionFilterBlock.vue?vue&type=script&lang=ts"

import "./RegionDashboardsAdditionFilterBlock.vue?vue&type=style&index=0&id=0e0bd85c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0bd85c"]])

export default __exports__